import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-courses-sorting.tsx
var LazyCoursesSorting = lazy(() => import("./courses-sorting-FIIxeVar.js").then((n) => n.n).then((module) => ({ default: module.CoursesSorting })));
function CoursesSorting({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-sorting" }),
		children: /* @__PURE__ */ jsx(LazyCoursesSorting, { ...props })
	});
}
function CoursesSortingContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-sorting" }),
		children: /* @__PURE__ */ jsx(LazyCoursesSorting, { ...props })
	});
}
var useCoursesSortingContent = () => {
	return useMemo(() => ({ coursesSorting: { component: CoursesSortingContent } }), []);
};
//#endregion
export { CoursesSorting, useCoursesSortingContent };
